import axios from "@/plugins/axios";

export default {
    findById(approachId) {
        return axios.httpApi.get("/approach-flow-rule/" + approachId);
    },
    save(_data, dataId) {

        let data = Object.assign({}, _data)
        if (dataId) {
            return axios.httpApi.patch("/approach-flow-rule/" + dataId, data);
        }
        return axios.httpApi.post("/approach-flow-rule", data);
    },
    saveMultiple(data) {
        return axios.httpApi.patch("/approach-flow/editMultiple", data);
    },
    list(approach_flow_id, active = true) {
        
        let params = {}

        if (approach_flow_id) {
            params.approach_flow_id = approach_flow_id
        }
        params.active = active
        params.limit = 9999
        return axios.httpApi.get("/approach-flow-rule", { params });
    },
    remove(ids) {
        var res = null;
        ids.forEach(id => {
            res = axios.httpApi.delete("/approach-flow-rule/" + id);
        })

        return res;
    }
  

};